import i18n from '@/i18n';
import store from './store';

var distributor = {
  dots_menu: function (params) {
    return [
      {
        title: i18n.t ('rms.DotMenu.switchCompany'),
        icon: 'rms_company_switch',
        route: 'Companies',
        allowed: true,
      },
      {
        title: i18n.t ('rms.DotMenu.invitation'),
        icon: 'rms_invite_peoples',
        route: 'CreateInvitation',
        allowed: params.allowed,
      },
      {
        title: i18n.t ('rms.DotMenu.linksStatus'),
        icon: 'rms_bell',
        route: 'ListInvitations',
        allowed: true,
      },
    ];
  },
};

var guest = {
  dots_menu: [
    {
      title: i18n.t ('rms.guest.DotMenu.your_wishlist'),
      icon: 'rms_favorite_filled',
      route: 'Wishlist',
      allowed: true,
    },
  ],
};
export {distributor, guest};
